<template>
  <div class="i-site-multi-picker">
    <div class="field-label">
      {{ resolvedLabel }}
    </div>
    <multiselect
      ref="multi"
      v-model="selected"
      label="name"
      trackBy="siteId"
      :options="sites"
      :multiple="false"
      :placeholder="resolvedPlaceholder"
      @search-change="onSearch"
      @select="onSelect"
      @remove="onRemove"
      @open="onOpen"
      @keydown="onKeydown"
    >
      <template #noOptions>
        {{ $t('common.listIsEmpty') }}
      </template>
      <template #noResult>
        {{ $t('common.noElementsFound') }}
      </template>
      <template #option="{ option }">
        <div>{{ option.name }}</div>
        <div v-if="showInfo" class="i-user-picker-email">{{ option.url }}</div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {listSites} from "@/services/api/app/office/recovery/share-point/sharePoint";
import {defaultPagination} from "@/services/pagination";

export default {
  name: 'ISitePicker',
  emits: ['input'],
  components: {Multiselect},
  props: {
    value: {},
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    filter: {
      type: Object,
      default: {
        "statuses": [
          1, 2, 4
        ]
      }
    },
    showInfo: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    resolvedLabel() {
      return this.label || this.$t('recovery.search.labels.site');
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('common.searchForSites');
    }
  },

  data() {
    return {
      selected: null,
      sites: []
    }
  },

  methods: {
    onSearch(searchTerm) {
      this.sites = [];
      this.loadSites(searchTerm)
    },
    loadSites(search = null) {
      listSites({
        pagination: {
          ...defaultPagination(),
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: this.filter
      })
        .then(({result, pagination}) => {
          this.sites = result;
        })
    },
    onSelect(data) {
      this.$emit('input', data)
    },
    onRemove(data) {
      this.$emit('input', null)
    },
    onOpen() {
      this.$nextTick(this.scrollHighlightedIntoView);
    },
    onKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        this.$nextTick(this.scrollHighlightedIntoView);
      }
    },
    scrollHighlightedIntoView() {
      const multi = this.$refs.multi;
      if (!multi || !multi.$el) return;

      const wrapper = multi.$el.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;

      const highlighted = wrapper.querySelector('.multiselect__option--highlight');
      if (highlighted) {
        highlighted.scrollIntoView({block: 'nearest'});
      }
    },
  },

  created() {
    if (this.value?.status != 4) {
      this.selected = this.value;
    }

    this.loadSites();
  },
}
</script>

<style lang="scss">
@import "IUserMultiPicker";
</style>
